
























import Vue from 'vue'
import VFacebookLogin from 'vue-facebook-login-component'
import GoogleLogin from 'vue-google-login'

export default Vue.extend({
  name: 'SocialLogin',
  components: {
    VFacebookLogin,
    GoogleLogin,
  },
  computed: {
    googleClientId: function (): string {
      return process.env.VUE_APP_GOOGLE_LOGIN_CLIENT_ID ?? ''
    },
    fbAppId: function (): string {
      return process.env.VUE_APP_FB_LOGIN_APP_ID ?? ''
    },
  },
  data: () => ({
    FB: {} as any,
    scope: {} as any,
  }),
  methods: {
    fbLoggedIn(response: any) {
      if (!response || !response.authResponse) {
        return
      }

      this.FB.api(
        '/me',
        { fields: 'email, first_name, last_name' },
        (meResponse: any) => {
          this.$store
            .dispatch('authentication/signInSocial', {
              url: '/login-fb',
              token: response.authResponse.accessToken,
              api: this.$api,
              email: meResponse.email,
              firstname: meResponse.first_name,
              lastname: meResponse.last_name,
            })
            .then(() => this.FB.logout())
        }
      )
    },
    fbSdkInit({ FB, scope }: any) {
      this.FB = FB
      this.scope = scope
    },
    googleLoggedIn(googleUser: any) {
      if (!googleUser) {
        return
      }

      this.$store
        .dispatch('authentication/signInSocial', {
          url: '/login-g',
          token: googleUser.getAuthResponse().access_token,
          api: this.$api,
          email: googleUser.getBasicProfile().getEmail(),
          firstname: googleUser.getBasicProfile().getGivenName(),
          lastname: googleUser.getBasicProfile().getFamilyName(),
        })
        .then(() => this.logoutGoogle())
    },
    logoutGoogle() {
      (Vue as any).GoogleAuth.then((auth2: any) => {
        auth2.signOut()
      })
    },
  },
})
